import { render, staticRenderFns } from "./TheAttachmentDisplayModal.vue?vue&type=template&id=0d04b885&scoped=true&lang=pug&"
import script from "./TheAttachmentDisplayModal.vue?vue&type=script&lang=js&"
export * from "./TheAttachmentDisplayModal.vue?vue&type=script&lang=js&"
import style0 from "./TheAttachmentDisplayModal.vue?vue&type=style&index=0&id=0d04b885&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d04b885",
  null
  
)

export default component.exports